import React, { useState, useCallback, useEffect } from "react";
import CertificationItem from "../../steps/Certification/CertificationItem";
import CertificationForm from "../../steps/Certification/CertificationForm";
import { useDispatch } from 'react-redux';
import { showModal } from '../../../../redux/system/actions';
import ConfirmModal from "../../../common/modals/ConfirmModal";
import {toast} from 'react-toastify';
import {COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../../service/toastService';
import {createCurriculumVitaeCertification, updateCurriculumVitaeCertification} from '../../../../api/curriculumVitaeApi';

const CONFIRM_MODAL_ID = 'confirmModal';

function CertificationMainMenu({ curriculumVitae, handleDeleteItem, setCurriculumVitae, status }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [certifications, setCertifications] = useState(curriculumVitae.curriculumVitaeCertifications || []);
    const [certificationToDelete, setCertificationToDelete] = useState(null);
    const [editingCertification, setEditingCertification] = useState(null);
    const [addingCertification, setAddingCertification] = useState(false);
   
    useEffect(() => {
        setCertifications(curriculumVitae.curriculumVitaeCertifications || []);
    }, [curriculumVitae.curriculumVitaeCertifications]);

    const confirmDeleteCertification = async (certification) => {
        setCertificationToDelete(certification);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    const handleSaveCertification = async (certificationData) => {
        try {
            let updatedCertifications = [...certifications];
            let newCertification = null;
        
            if (editingCertification) {
                const id = editingCertification.id;
                newCertification = await updateCurriculumVitaeCertification(id, certificationData); 
                updatedCertifications = updatedCertifications.map((certification) =>
                certification.id === id ? newCertification.data : certification
            );
            toast.success('Certification updated successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
            } else {
                newCertification = await createCurriculumVitaeCertification(certificationData);
                updatedCertifications.push(newCertification.data);
                toast.success('Certification added successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
            }
        
            setCertifications(updatedCertifications);
            setCurriculumVitae((prevCv) => ({
                ...prevCv,
                curriculumVitaeCertifications: updatedCertifications,
            }));
            setEditingCertification(null);
            setAddingCertification(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
        }
    };

    const handleEditCertification = (certification) => {
        const sanitizedCertification = {
            ...certification,
            expiryDate: certification.expiryDate?.startsWith('0001-01-01') ? '' : certification.expiryDate
        };
        setEditingCertification(sanitizedCertification);
    };

    return (
        <div className="cv-main-menu-overview">
            {(editingCertification || addingCertification) ? (
                <>
                    <h3 className="cv-main-menu-edit-mode">
                        {editingCertification ? 'Edit Mode' : 'Add Certification'}
                    </h3>
                    <div className="main-menu-form-wrapper">
                        <CertificationForm
                            curriculumVitaeId={curriculumVitae.id}
                            initialCertification={editingCertification}
                            setEditingCertification={setEditingCertification}
                            setAddingCertification={setAddingCertification}
                            onSave={(certificationData) => handleSaveCertification(certificationData)}
                            status={status}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="cv-main-menu-list">
                    {curriculumVitae.curriculumVitaeCertifications.map((certification) => (
                        <div key={certification.id} className="main-menu-item-wrapper">
                            <CertificationItem
                                certification={certification}
                                onEdit={handleEditCertification}
                                onDelete={() => confirmDeleteCertification(certification.id)}
                            />
                        </div>
                    ))}
                    </div>
                    <button className="cv-main-menu-add" onClick={() => setAddingCertification(true)}>
                        <i className="pe-7s-plus mr-2"></i>
                        Add another certification
                    </button>
                </>
            )}

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this Certification?"
                message="This will permanently remove the selected Certification from your profile. Do you wish to proceed?"
                onConfirm={() => handleDeleteItem(certificationToDelete, 'curriculumVitaeCertifications')}
            />
        </div>
    );
}

export default CertificationMainMenu;

